var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "review-content"
  }, [_c('h3', {
    staticClass: "top"
  }, [_vm._v("评论")]), _c('div', {
    staticClass: "content"
  }), _c('div', {
    staticClass: "bottom"
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "border": false,
      "autosize": {
        minRows: 5,
        maxRows: 8
      },
      "placeholder": "输入内容..."
    },
    model: {
      value: _vm.commentText,
      callback: function ($$v) {
        _vm.commentText = $$v;
      },
      expression: "commentText"
    }
  }), _c('div', {
    staticClass: "bottom-button"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "ghost": ""
    }
  }, [_vm._v("设为任务")]), _c('Button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "primary",
      "ghost": ""
    },
    on: {
      "click": _vm.createCommentMethod
    }
  }, [_vm._v("发表评论")])], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }